export default __webpack_public_path__ + "static/media/data.71b6c07d.svg";